import React, { useState, useRef } from "react";
import { Button } from "react-bootstrap";
import { PapperBoatIcon } from "../Icons";
import "./VoiceMsg.scss"; // Optional: custom styles

const VoiceMsg = ({ onAudioRecorded, blocked, sendingImage }) => {
  const [recording, setRecording] = useState(false);
  const [audioURL, setAudioURL] = useState(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      audioChunksRef.current = [];

      mediaRecorderRef.current.ondataavailable = (e) => {
        if (e.data.size > 0) {
          audioChunksRef.current.push(e.data);
        }
      };

      mediaRecorderRef.current.onstop = () => {
        const blob = new Blob(audioChunksRef.current, { type: "audio/webm" });
        const url = URL.createObjectURL(blob);
        setAudioURL(url);

        const file = new File([blob], "voice_note.webm", {
          type: "audio/webm",
        });
        if (onAudioRecorded) onAudioRecorded(file);
      };

      mediaRecorderRef.current.start();
      setRecording(true);
    } catch (error) {
      console.error("Microphone access denied:", error);
    }
  };

  const stopRecording = () => {
    mediaRecorderRef.current.stop();
    setRecording(false);
  };

  const resetRecording = () => {
    setAudioURL(null);
    onAudioRecorded(null);
  };

  return (
    <div className="voice-msg-wrapper d-flex align-items-center gap-2">
      {audioURL ? (
        <>
          <audio controls src={audioURL} className="audio-preview" />

          <div className="send-message ">
            <Button
              variant="primary"
              onClick={resetRecording}
              title="Re-record"
              size="sm"
            >
              Cancel
            </Button>
          </div>
          <div className="send-message">
            <Button
              disabled={blocked || sendingImage}
              variant="primary"
              type="submit"
              title="Send"
              onClick={() => {
                onAudioRecorded("send");
                // Reset state after send
                setAudioURL(null);
                setRecording(false);
              }}
              size="sm"
            >
              <PapperBoatIcon />
            </Button>
          </div>
        </>
      ) : recording ? (
        <Button
          variant="danger"
          onClick={stopRecording}
          title="Stop Recording"
          size="sm"
        >
          ⏹️ Stop
        </Button>
      ) : (
        <Button
          variant="outline-primary"
          onClick={startRecording}
          disabled={blocked}
          title="Start Recording"
          size="sm"
        >
          🎤 Voice
        </Button>
      )}
    </div>
  );
};

export default VoiceMsg;
